/* Project Import will be here */
import { getErrorObject, errorToast } from "utilities/utils";
import { getLoyaltyDashboardDetailsApi } from "services/rewards/rewards";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    LOYALTY_DASHBOARD_REQUEST: "loyaltyDashboardDetails/LOYALTY_DASHBOARD_REQUEST",
    LOYALTY_DASHBOARD_SUCCESS: "loyaltyDashboardDetails/LOYALTY_DASHBOARD_SUCCESS",
    LOYALTY_DASHBOARD_FAILURE: "loyaltyDashboardDetails/LOYALTY_DASHBOARD_FAILURE"
};

const initialState = {
    data: {},
    isLoading: false,
};

export const loyaltyDashboardDetails = (state = initialState, action) => {
    switch (action.type) {
        case types.LOYALTY_DASHBOARD_REQUEST:
            return {
                ...state,
                isLoading: true
            };

        case types.LOYALTY_DASHBOARD_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isLoading: false
            };

        case types.LOYALTY_DASHBOARD_FAILURE:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

/* Get current financial year target vs achievement data */
export const getLoyaltyDashboardDetails = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.LOYALTY_DASHBOARD_REQUEST });
        try {
            const response = await getLoyaltyDashboardDetailsApi();
            dispatch({
                type: types.LOYALTY_DASHBOARD_SUCCESS,
                payload: { data: response.data.Data }
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.LOYALTY_DASHBOARD_FAILURE, false));
        }
    }
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "") {
            dispatch({
                type: type,
                payload: { error: message }
            });
        }

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};